import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    reason:
      'We are sorry, we cannot open your account if you have a tax residence in {country}.',
    reasonWithMissingCountry:
      'We are sorry, we cannot open your account if you have a tax residence in this country.',
  },
  fr: {
    reason:
      'Nous sommes désolés, nous ne pouvons pas ouvrir votre compte si vous avez une résidence fiscale dans le pays suivant\u00A0: {country}.',
    reasonWithMissingCountry:
      'Nous sommes désolés, nous ne pouvons pas ouvrir votre compte si vous avez une résidence fiscale dans ce pays.',
  },
} as const);
